module.exports = __webpack_public_path__ + "static/media/542JamesPBrawleyDrNW_2018-06-12_176.52676938.jpg";